"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9518,1412],{

/***/ 57347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ NltOffers_MobileActionBar; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/uikit/Sticky/index.tsx
var Sticky = __webpack_require__(26432);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var hooks_dist_index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 1 modules
var modal_dist_index_esm = __webpack_require__(83292);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./src/redux/nlt-offer/actions.ts
var actions = __webpack_require__(26869);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/NltOffers/SortsModal.tsx










const SortsModal = () => {
  const dispatch = (0,es/* useDispatch */.I0)();
  const {
    isOpen,
    onOpen,
    onClose
  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
  const orders = (0,es/* useSelector */.v9)(state => state.nlt.orders);
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();

  const changeOrderHandler = value => dispatch((0,actions/* toggleOrder */.YQ)(value));

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
      w: "100%",
      h: "14",
      as: "button",
      onClick: onOpen,
      children: [t('nltActionbarContainer:sortBy'), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ChevronDownIcon */.v4, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* Drawer */.dy, {
      placement: "bottom",
      onClose: onClose,
      isOpen: isOpen,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerOverlay */.P1, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* DrawerContent */.sc, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerCloseButton */.cC, {
          mt: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerHeader */.OX, {
          borderBottomWidth: "1px",
          children: t('nltMobileFiltersModalContainer:doSort')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerBody */.Ng, {
          children: orders.map(sort => /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
            borderRadius: "0",
            w: "100%",
            bg: "baseWhite",
            mt: "xxs",
            onClick: () => changeOrderHandler(sort.value),
            fontWeight: "normal",
            children: sort.label || sort.name
          }, sort.value))
        })]
      })]
    })]
  });
};

/* harmony default export */ var NltOffers_SortsModal = (SortsModal);
// EXTERNAL MODULE: ./src/icons/filters.tsx
var filters = __webpack_require__(11101);
// EXTERNAL MODULE: ./src/components/NltOffers/FiltersList.tsx + 10 modules
var FiltersList = __webpack_require__(94974);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersModal.tsx











const FiltersModal = () => {
  const dispatch = (0,es/* useDispatch */.I0)();
  const {
    isOpen,
    onOpen,
    onClose
  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const offers = (0,es/* useSelector */.v9)(state => state.nlt.filteredOffers);
  const selectedFilters = (0,es/* useSelector */.v9)(state => state.nlt.selectedFilters);
  let selectedFiltersCount = 0;
  (0,react.useEffect)(() => {
    selectedFiltersCount = selectedFilters.reduce((prev, current) => prev + current.items.length, 0);
  }, []);

  const resetFiltersHandler = () => {
    dispatch((0,actions/* resetAllFilters */._4)());
    onClose();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Center */.M5, {
      w: "100%",
      h: "14",
      bg: "primaryGreen.300",
      as: "button",
      onClick: onOpen,
      children: [selectedFiltersCount > 0 ? t('nltActionbarContainer:filters', {
        count: selectedFiltersCount
      }) : t('nltActionbarContainer:showFilters'), /*#__PURE__*/(0,jsx_runtime.jsx)(filters/* default */.Z, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* Modal */.u_, {
      onClose: onClose,
      size: "full",
      isOpen: isOpen,
      scrollBehavior: "inside",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
          textAlign: "center",
          children: t('nltMobileFiltersModalContainer:doFilter')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {
          mt: "1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
          p: "0",
          bg: "baseNeutral.200",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FiltersList/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalFooter */.mz, {
          display: "block",
          padding: "0",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Wrap */.Eq, {
            spacing: "0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* WrapItem */.Uc, {
              w: "50%",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                w: "100%",
                h: "14",
                borderColor: "primaryGreen.300",
                color: "primaryGreen.900",
                variant: "outline",
                borderRadius: "0",
                onClick: resetFiltersHandler,
                children: t('nltMobileFiltersModalContainer:resetFilters')
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* WrapItem */.Uc, {
              w: "50%",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                w: "100%",
                h: "14",
                bg: "primaryGreen.300",
                as: "button",
                onClick: onClose,
                children: t('nltMobileFiltersModalContainer:showFoundOffer', {
                  value: offers.results
                })
              })
            })]
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var NltOffers_FiltersModal = (FiltersModal);
;// CONCATENATED MODULE: ./src/components/NltOffers/MobileActionBar.tsx







const MobileActionBar = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Sticky/* default */.Z, {
    h: "14",
    visible: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Wrap */.Eq, {
      spacing: "0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* WrapItem */.Uc, {
        w: "50%",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_SortsModal, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* WrapItem */.Uc, {
        w: "50%",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersModal, {})
      })]
    })
  });
};

/* harmony default export */ var NltOffers_MobileActionBar = (MobileActionBar);

/***/ }),

/***/ 11101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const FiltersIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      fill: "#1B4832",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M8.25 11.25c.98 0 1.814.626 2.122 1.5H16.1c.22 0 .4.18.4.4v.7c0 .22-.18.4-.4.4h-5.728c-.31.874-1.142 1.5-2.122 1.5s-1.813-.626-2.122-1.5H1.9c-.22 0-.4-.18-.4-.4v-.7c0-.22.18-.4.4-.4h4.228c.308-.874 1.142-1.5 2.122-1.5zm0 1.2c-.58 0-1.05.47-1.05 1.05 0 .58.47 1.05 1.05 1.05.58 0 1.05-.47 1.05-1.05 0-.58-.47-1.05-1.05-1.05zm4.5-5.7c.98 0 1.814.626 2.122 1.5H16.1c.22 0 .4.18.4.4v.7c0 .22-.18.4-.4.4h-1.228c-.31.874-1.142 1.5-2.122 1.5s-1.813-.626-2.122-1.5H1.9c-.22 0-.4-.18-.4-.4v-.7c0-.22.18-.4.4-.4h8.728c.308-.874 1.142-1.5 2.122-1.5zm0 1.2c-.58 0-1.05.47-1.05 1.05 0 .58.47 1.05 1.05 1.05.58 0 1.05-.47 1.05-1.05 0-.58-.47-1.05-1.05-1.05zM6 2.25c.98 0 1.814.626 2.122 1.5H16.1c.22 0 .4.18.4.4v.7c0 .22-.18.4-.4.4H8.122c-.31.874-1.142 1.5-2.122 1.5s-1.813-.626-2.122-1.5H1.9c-.22 0-.4-.18-.4-.4v-.7c0-.22.18-.4.4-.4h1.978C4.186 2.877 5.02 2.25 6 2.25zm0 1.2c-.58 0-1.05.47-1.05 1.05 0 .58.47 1.05 1.05 1.05.58 0 1.05-.47 1.05-1.05 0-.58-.47-1.05-1.05-1.05z",
        transform: "translate(-318 -1991) translate(0 1972) translate(187) translate(131 19)"
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (FiltersIcon);

/***/ }),

/***/ 26432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71197);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["visible", "children", "height", "h"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const Sticky = _ref => {
  let {
    visible,
    children,
    height,
    h
  } = _ref,
      other = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Slide */ .Mi, {
    direction: "bottom",
    style: {
      zIndex: 2
    },
    in: visible,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, _objectSpread(_objectSpread({
      bg: "baseWhite",
      boxShadow: "0 -2px 10px 0px rgba(0, 0, 0, 0.08)",
      h: height || h
    }, other), {}, {
      children: children
    }))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Sticky);

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);